export default __webpack_public_path__ + "static/jaworski-72d4042125aa461eec187b263d57e47e.jpeg";